// import React from 'react';
// import Header from './components/Header';
// import Hero from './components/Hero';
// import PopularDestinations from './components/PopularDestinations';
// import PhotoGallery from './components/PhotoGallery';
// import FormSection from './components/FormSection';
// import AboutUs from './components/AboutUs';
// import OurServices from './components/OurServices';
// import EasySteps from './components/EasySteps';
// import MeetOurGuide from './components/MeetOurGuide';
// import Testimonials from './components/Testimonials';
// import Footer from './components/Footer';
// import PrivacyPolicy from './components/PrivacyPolicy';

// function App() {
//   return (
//     <div className="App">
//       <Header />
//       <Hero />
//       <AboutUs />
//       <PopularDestinations />
//       <PhotoGallery />
//       <FormSection />
//       <OurServices />
//       <EasySteps />
//       <Testimonials />
//       <Footer />
//     </div>
//   );
// }

// export default App;

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import PopularDestinations from './components/PopularDestinations';
import PhotoGallery from './components/PhotoGallery';
import FormSection from './components/FormSection';
import AboutUs from './components/AboutUs';
import OurServices from './components/OurServices';
import EasySteps from './components/EasySteps';
import MeetOurGuide from './components/MeetOurGuide';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';

function Home() {
  return (
    <>
      <Header />
      <Hero />
      <AboutUs />
      <PopularDestinations />
      <PhotoGallery />
      <FormSection />
      <OurServices />
      <EasySteps />
      <Testimonials />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
